import * as t from 'io-ts';
import {
    FormFieldC,
    RawFormFieldC,
} from '@/scripts/helpers/schemaConverter/converters/types/FormField';
import { PaginationDataC } from '@/scripts/types/Table/PaginationData';
import { NotificationC } from './Notification';

export const NotificationsPopupResponseC = t.type({
    newNotificationsCount: t.number,
    form: RawFormFieldC,
    paginator: t.type({
        paginationData: PaginationDataC,
        items: t.array(NotificationC),
    }),
});

export type NotificationsPopupResponse = t.TypeOf<typeof NotificationsPopupResponseC>;

export const NotificationFormC = FormFieldC;
